const API_URL = process.env.REACT_APP_API_URL || "https://dev-api.sulavsewanepal.com";
export default API_URL;